import { Collection, WhereField } from '../../shared/constants'
import { getAllDocsByCollection, getDocByQueries, updateDoc } from './collectionBaseWorker'
import { where } from "firebase/firestore"

export const getRemotesConfig = async () => {
    return getAllDocsByCollection({ collection: Collection.REMOTE_CONFIG })
}

export const getRemoteConfigByKey = async ({ key }) => {
    return await getDocByQueries({
        collection: Collection.REMOTE_CONFIG,
        queries: [
            where(WhereField.KEY, "==", key)
        ]
    })
}

export const getRemoteConfigByKeyAsBoolean = async ({ key }) => {
    const item = await getRemoteConfigByKey({ key: key })
    return item.value === "true"
}

export const getAllRemoteConfig = async () => {
    return await getAllDocsByCollection({ collection: Collection.REMOTE_CONFIG })
}